import React, { Component } from 'react';
import EditBar from '../EditBar/EditBar';
import './Html.css';

class Html extends Component {
  toggleEditing(toggle) {
    if (this.props.onToggleEditing) {
      this.props.onToggleEditing(toggle);
    }
  }

  render() {
    const {
      sectionIndex,
      contentBlockIndex,
      removeContentBlock,
      html
    } = this.props;

    return (
      <div className={`html edit-wrapper${!html ? ' no-content' : ''}`}>
        {!html ? (
          <div>Edit to add HTML</div>
        ) : (
          <div dangerouslySetInnerHTML={{ __html: html }} />
        )}

        <EditBar
          toggleEditing={() => this.toggleEditing(true)}
          removeContentBlock={() =>
            removeContentBlock(sectionIndex, contentBlockIndex)
          }
        />
      </div>
    );
  }
}

export default Html;



// WEBPACK FOOTER //
// ./src/components/landingPage/Html/Html.js